import { render, staticRenderFns } from "./InvoiceDraftInfo.vue?vue&type=template&id=4afa5685&scoped=true&"
import script from "./InvoiceDraftInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceDraftInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDraftInfo.vue?vue&type=style&index=0&id=4afa5685&prod&lang=css&"
import style1 from "./InvoiceDraftInfo.vue?vue&type=style&index=1&id=4afa5685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa5685",
  null
  
)

export default component.exports